<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  delay: {
    type: Number,
    default: 250
  },
  data: {
    type: Array,
    default: null,
    validator: function(value) {
      return value.every(item => Object.keys(item).includes('key') && Object.keys(item).includes('value'))
    }
  },
  loadData: {
    type: Function,
    default: null
  },
})

const loadedData = ref(null)
const isLoading = ref(false)

const rows = computed(() => (loadedData.value ?? props.data ?? []).filter(item => item.value != null && item.value !== ''))

const onBeforeShow = async() => {
  if (!props.loadData || loadedData.value || isLoading.value) return
  isLoading.value = true
  try {
    loadedData.value = await props.loadData()
  } finally {
    isLoading.value = false
  }
}

</script>
<template>
  <q-tooltip
    anchor="bottom middle"
    :delay="props.delay"
    self="top middle"
    style="background-color: transparent"
    @before-show="onBeforeShow"
  >
    <q-card
      class="shadow-5 no-border-radius"
    >
      <div v-if="isLoading" class="q-pa-md flex flex-center">
        <q-spinner color="primary" size="md" />
      </div>
      <q-markup-table v-else>
        <tbody>
          <tr
            v-for="(item, index) in rows"
            :key="index"
          >
            <td class="text-left table-cell">
              {{ item.key }}
            </td>
            <td :class="['text-right text-bold table-cell', item.class]">
              {{ item.value }}
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-card>
  </q-tooltip>
</template>

<style scoped lang="scss">
  .no-border-radius {
    border-radius: 0 !important;
  }

  .group-title {
    color: $primary;
    font-weight: bold;
  }

  .table-cell {
    height: 2.25rem;
  }
</style>
